var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.22222 0C0.996528 0 0 1.025 0 2.28571V3.42857H20V2.28571C20 1.025 19.0035 0 17.7778 0H2.22222ZM20 6.85714H0V13.7143C0 14.975 0.996528 16 2.22222 16H17.7778C19.0035 16 20 14.975 20 13.7143V6.85714ZM3.88889 11.4286H6.11111C6.41667 11.4286 6.66667 11.6857 6.66667 12C6.66667 12.3143 6.41667 12.5714 6.11111 12.5714H3.88889C3.58333 12.5714 3.33333 12.3143 3.33333 12C3.33333 11.6857 3.58333 11.4286 3.88889 11.4286ZM7.77778 12C7.77778 11.6857 8.02778 11.4286 8.33333 11.4286H12.7778C13.0833 11.4286 13.3333 11.6857 13.3333 12C13.3333 12.3143 13.0833 12.5714 12.7778 12.5714H8.33333C8.02778 12.5714 7.77778 12.3143 7.77778 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardWhite);
export default __webpack_public_path__ + "static/media/card-white.31d91b6ebb74c560f9f3632a3408570a.svg";
export { ForwardRef as ReactComponent };